import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { App as AntApp } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './App.css';
import './styles/globals.css';

import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import { LanguageProvider } from './contexts/LanguageContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import DocumentUploadPage from './pages/DocumentUploadPage';
import JobHistoryPage from './pages/JobHistoryPage';
import ShippingPage from './pages/ShippingPage';
import AddShippingRecordPage from './pages/AddShippingRecordPage';
import DeletedRecordsPage from './pages/DeletedRecordsPage';
import RepairPage from './pages/RepairPage';
import PrepaidPage from './pages/PrepaidPage';
import VehiclePage from './pages/VehiclePage';
import VehicleTrackingPage from './pages/VehicleTrackingPage';
import DriverPage from './pages/DriverPage';
import ShippingCostAnalysisPage from './pages/ShippingCostAnalysisPage';
import FuelReceiptPage from './pages/FuelReceiptPage';
import AddEditPricePage from './pages/AddEditPricePage';
import PriceHistoryPage from './pages/PriceHistoryPage';
import ShippingPriceMatrixPage from './pages/ShippingPriceMatrixPage';
import ShippingPriceByCapacityHistoryPage from './pages/ShippingPriceByCapacityHistoryPage';
import FeeStructurePage from './pages/FeeStructurePage';
import VehicleCapacityTonsPage from './pages/VehicleCapacityTonsPage';
import SettingsPage from './pages/SettingsPage';
import CustomerPage from './pages/CustomerPage';
import { authApi } from './services/api';

function App() {
  return (
    <AntApp>
      <LanguageProvider>
  <Router>
          <div className="App">
     {authApi.isAuthenticated() && <Navbar />}
<div className="container-fluid">
              <Routes>
     <Route path="/login" element={<LoginPage />} />
    <Route path="/" element={
         <ProtectedRoute>
<Navigate to="/dashboard" replace />
          </ProtectedRoute>
       } />
      <Route path="/dashboard" element={
     <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
   } />
    <Route path="/users" element={
          <ProtectedRoute requiredRole="Admin">
           <UsersPage />
        </ProtectedRoute>
             } />
            <Route path="/change-password" element={
           <ProtectedRoute>
         <ChangePasswordPage />
            </ProtectedRoute>
    } />
       <Route path="/document-upload" element={
     <ProtectedRoute>
  <DocumentUploadPage />
            </ProtectedRoute>
        } />
        <Route path="/document-upload/history" element={
          <ProtectedRoute>
            <JobHistoryPage />
          </ProtectedRoute>
        } />
   <Route path="/shipping" element={
      <ProtectedRoute>
          <ShippingPage />
      </ProtectedRoute>
      } />
   <Route path="/shipping/add" element={
     <ProtectedRoute>
<AddShippingRecordPage />
        </ProtectedRoute>
            } />
  <Route path="/shipping/edit/:id" element={
                  <ProtectedRoute>
        <AddShippingRecordPage />
          </ProtectedRoute>
        } />
     <Route path="/shipping/deleted" element={
     <ProtectedRoute requiredRole="Admin">
           <DeletedRecordsPage />
              </ProtectedRoute>
          } />
  <Route path="/repair" element={
     <ProtectedRoute>
   <RepairPage />
      </ProtectedRoute>
         } />
                <Route path="/prepaid" element={
        <ProtectedRoute>
       <PrepaidPage />
  </ProtectedRoute>
} />
            <Route path="/vehicles" element={
 <ProtectedRoute>
        <VehiclePage />
           </ProtectedRoute>
      } />
  <Route path="/vehicle-tracking" element={
           <ProtectedRoute>
        <VehicleTrackingPage />
        </ProtectedRoute>
     } />
    <Route path="/shipping/cost-analysis" element={
 <ProtectedRoute>
 <ShippingCostAnalysisPage />
 </ProtectedRoute>
    } />
     <Route path="/drivers" element={
     <ProtectedRoute>
  <DriverPage />
      </ProtectedRoute>
     } />
           <Route path="/fuel-receipts" element={
       <ProtectedRoute>
        <FuelReceiptPage />
      </ProtectedRoute>
         } />
 <Route path="/pricing/manage" element={
        <ProtectedRoute>
     <AddEditPricePage />
    </ProtectedRoute>
        } />
          <Route path="/pricing/history" element={
    <ProtectedRoute>
         <PriceHistoryPage />
    </ProtectedRoute>
     } />
      <Route path="/pricing/capacity-matrix" element={
     <ProtectedRoute>
  <ShippingPriceMatrixPage />
        </ProtectedRoute>
    } />
      <Route path="/pricing/capacity-history" element={
        <ProtectedRoute>
          <ShippingPriceByCapacityHistoryPage />
        </ProtectedRoute>
      } />
      <Route path="/pricing/fee-structure" element={
        <ProtectedRoute>
      <FeeStructurePage />
   </ProtectedRoute>
  } />
     <Route path="/vehicles/capacity-tons" element={
          <ProtectedRoute>
     <VehicleCapacityTonsPage />
        </ProtectedRoute>
          } />
          <Route path="/settings" element={
         <ProtectedRoute>
         <SettingsPage />
     </ProtectedRoute>
    } />
                <Route path="/customers" element={
            <ProtectedRoute>
          <CustomerPage />
                  </ProtectedRoute>
      } />
          </Routes>
        </div>
  </div>
 </Router>
      </LanguageProvider>
    </AntApp>
  );
}

export default App;
